import {
  Outlet,
  useLocation,
  useNavigate,
  useSearchParams,
} from 'react-router-dom';
import { AppProvider } from '@toolpad/core/AppProvider';
import { DashboardLayout } from '@toolpad/core/DashboardLayout';
import { NAVIGATION } from '../DashboardPage/navigation';

import AppLink from 'components/common/AppLink/AppLink';
import SidebarLogout from 'components/buttons/SidebarLogout/SidebarLogout';
import { theme } from 'theme';

export default function MainPage() {
  const location = useLocation();
  const navigateRR = useNavigate();
  const [searchParams] = useSearchParams();

  return (
    <AppProvider
      navigation={NAVIGATION}
      router={{
        pathname: location.pathname,
        searchParams,
        navigate: (url) => {
          navigateRR(typeof url === 'string' ? url : url.pathname);
        },
        Link: AppLink,
      }}
      branding={{
        title: 'Mazyona'
      }}
      theme={theme}
    >
      <DashboardLayout
        slots={{
          sidebarFooter: SidebarLogout,
        }}
        sx={{
          '& a:hover, & button:hover': {
            color: 'inherit',
          },
        }}>
        <Outlet />
      </DashboardLayout>
    </AppProvider>
  );
}
